export const environment = {
    production: false,
    apiService_Auth: '/backend-login',
    apiService: '/backend-soporte',
    apiService_Erp: '/backend-erp',
    apiService_Report: '/backend-export',
    apiService_Produccion: '/backend-prod-api',
    apiService_Adjuntos: '/backend-adjuntos',
    apiService_FE: '/backend-fe',
    apiService_Config: '/backend-config',
    apiService_Notificaciones: '/backend-notification',
    serviceUrl_Planilla: '/backend-planilla',
    serviceUrl_Migra_Api: '/backend-migra-api',
    apiService_Token: '/backend-token',
    apiService_Report_Dynamic: '/backend-report-dynamic',
    recaptcha: {
        siteKey: '6Ld4ZT0sAAAAAG9XH7-7d4s_0EAIToZXpeeCJGO5',
    },
    PRODUCTO:'RECURSOS',
    URL_CONFIGURACION: 'url_configuracion',
    URL_ANALYTICS: 'url_analytics',
    NEW_TSI_APP: 'url_new_erp_app'
}